import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import img1 from '../../assets/cars-bg5.jpg'
import img2 from '../../assets/car-type.jpg'
import Background from '../CarList/Background';
import { MdDoubleArrow, MdLocalPhone, MdOutlineMailOutline } from "react-icons/md";
import axios from 'axios';


const Index = () => {
    const baseURL = useSelector((state) => state?.config?.baseURL)
    const [contactData, setContactData] = useState(null);

    useEffect(() => {
        axios.get(`${baseURL}/contact/fetchcontactUs`)
            .then(response => {
                setContactData(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching contact data:', error);
            });
    }, []);

    return (
        <div className='container-fluid px-0'>
            <Background
                image={contactData?.image1 ? `${baseURL}${contactData?.image1}` : img1}
                name="Contact Us"
            />
            <div>
                <div className='container my-3 pb-6'>
                    <div className='row pt-5'>
                        <div className='col-md-6 contact-img'>
                            <img src={contactData?.image2 ? `${baseURL}${contactData?.image2}` : img2} className='img-fluid' alt="Contact" />
                        </div>
                        <div className='col-md-6 d-flex justify-content-center flex-column px-2 px-md-4'>
                            <h2 className='d-flex flex-row accentColor text-lg-star align-items-center mb-2'>
                                <span className='lh-0'><MdDoubleArrow /></span><span className='font'>{contactData?.title ? contactData?.title : 'Contact Us'}</span>
                            </h2>
                            <p className='text-secondary text-lg-start'>
                                {contactData?.description ? contactData?.description : 'Loading...'}
                            </p>
                            <div className='mt-4 px-4 px-lg-0'>
                                <div className='d-flex flex-row align-items-center my-4'>
                                    <div className='contact-ring me-2'>
                                        <MdOutlineMailOutline className='contact-icon' />
                                    </div>
                                    <div>
                                        <p className='text-secondary'>Email Id</p>
                                        <p>{contactData?.email ? contactData?.email : 'Loading...'}</p>
                                    </div>
                                </div>
                                <div className='d-flex flex-row align-items-center my-4'>
                                    <div className='contact-ring me-2'>
                                        <MdLocalPhone className='contact-icon' />
                                    </div>
                                    <div>
                                        <p className='text-secondary'>Phone Number</p>
                                        <p>{contactData?.phone ? contactData?.phone : 'Loading...'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index;
